<template>
  <section id="homeSlider">
    <Header />

    <div class="slider-area fix p-relative">
      <div class="slider-active swiper-container h-75">
        <swiper
          ref="mySwiper"
          :modules="modules"
          :effect="'fade'"
          :loop="true"
          :navigation="{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }"
          :autoplay="{ delay: 5000 }"
        >
          <swiper-slide v-for="item in sliderData" :key="item.id">
            <div
              class="slider-list slider-height-2 swiper-slide d-flex align-items-center pt-70"
            >
              <div
                class="slider-bg img-zoom"
                :style="{
                  backgroundImage:
                    'url(' + require('@/assets/img/slider/' + item.img) + ')',
                  backgroundPosition: bottom,
                }"
              ></div>
              <div class="container p-relative">
                <div class="row h-100">
                  <div class="col-12 position-relative">
                    <div class="slider-text slider-text-2 z-index">
                      <h2 class="slider-title" v-html="item.title"></h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>

        <!-- If we need pagination -->
        <!-- <div class="swiper-pagination"></div> -->

        <!-- If we need navigation buttons -->
        <div class="swiper-button-prev sp-arrow">
          <vue-feather
            size="24"
            stroke="white"
            type="chevron-left"
          ></vue-feather>
        </div>
        <div class="swiper-button-next sp-arrow">
          <vue-feather
            size="24"
            stroke="white"
            type="chevron-right"
          ></vue-feather>
        </div>
      </div>

    </div>

  </section>
</template>

  <script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, EffectFade, Autoplay } from "swiper";
import "@bhplugin/vue3-datatable/dist/style.css";

export default {
  name: "HomeTwoSlider",
  components: {
    Swiper,
    SwiperSlide,

  },
  data() {
    return {
      showNews: true,
      showMinistry: false,
      showCompanies: true,
      showTrainingCompanies: false,
      sliderData: [
        {
          id: "1",
          img: "bg1.jpg",
          title: "نظام الشهادات ",
        },
        {
          id: "2",
          img: "bg2.jpg",
          title: "نظام منح الشهادات ",
        },
      ],
      itemsPerPage: 2,
        currentPage: 1,
        totalPages: 5,

    };
  },
  setup() {
    return {
      modules: [Navigation, EffectFade, Autoplay],
    };
  },

  methods: {

  },
};
</script>